// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/foundations/icons/circle-check-green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("src/foundations/icons/circle-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("src/foundations/icons/triangle-exclamation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("src/foundations/icons/circle-info-warning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("src/foundations/icons/circle-info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("src/foundations/icons/rotate.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("src/foundations/icons/lock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("src/foundations/icons/magnifying-glass.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("src/foundations/icons/user-large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("src/foundations/icons/arrow-right-from-bracket.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("src/foundations/icons/file-pdf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("src/foundations/icons/comment.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("src/foundations/icons/save.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("src/foundations/icons/trash-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("src/foundations/icons/circle-xmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("src/foundations/icons/circle-xmark-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("src/foundations/icons/clock-rotate-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("src/foundations/icons/clone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("src/foundations/icons/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("src/foundations/icons/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("src/foundations/icons/direction.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("src/foundations/icons/arrow-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    position: relative;
    display: inline-block;
}
:host([kind]) img {
    display: block;
    width: var(--p2-regular-font-size);
    height: var(--p2-regular-font-size);
    margin-left: var(--spacing-05);
    margin-right: var(--spacing-05);
}
:host([kind="success"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
:host([kind="check"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
:host([kind="error"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
:host([kind="warning"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
:host([kind="info"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
:host([kind="rotate"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
:host([kind="lock"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
:host([kind="search"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
:host([kind="user"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
:host([kind="logout"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
:host([kind="pdf"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
:host([kind="comment"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
:host([kind="save"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
:host([kind="trash-red"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
:host([kind="remove"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
:host([kind="remove-red"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
:host([kind="history"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
:host([kind="clone"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
:host([kind="edit"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
:host([kind="plus"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
:host([kind="direction-down"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    transform: rotate(0deg);
}
:host([kind="direction-up"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    transform: rotate(180deg);
}
:host([kind="arrow-right"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
:host([kind="arrow-left"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    transform: rotate(180deg);
}
:host([kind="arrow-up"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    transform: rotate(270deg);
}
:host([kind="arrow-down"]) img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    transform: rotate(90deg);
}

/* =============================================================================
   m icons
   ===========================================================================*/
:host([size="m"]) img {
    display: block;
    width: var(--headings-h4-font-size);
    height: var(--headings-h4-font-size);
    margin-left: var(--spacing-05);
    margin-right: var(--spacing-05);
}
/* =============================================================================
   lg icons
   ===========================================================================*/
:host([size="lg"]) img {
    display: block;
    width: var(--headings-h2-font-size);
    height: var(--headings-h2-font-size);
    margin-left: var(--spacing-05);
    margin-right: var(--spacing-05);
}

/* =============================================================================
   disabled icons
   ===========================================================================*/
:host([disabled]) img {
    opacity: .4;
    cursor: default;
}

/* =============================================================================
   animated arrow icons
   ===========================================================================*/
:host([kind="direction-down"]) img.animate,
:host([kind="direction-up"]) img.animate {
    transition: transform .13s linear;
}
/*animated icons start with con configuration far from the ideal onde*/
:host([kind="direction-down"][animate]) img {
    transform: rotate(180deg);
}
:host([kind="direction-up"][animate]) img {
    transform: rotate(0deg);
}
/*and then return to the ideal configuration via animation*/
:host([kind="direction-down"][animate]) img.animate {
    transform: rotate(0deg);
}
:host([kind="direction-up"][animate]) img.animate {
    transform: rotate(180deg);
}


`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/icon/style/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,mCAAmC;IACnC,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,gDAA4D;AAChE;AACA;IACI,gDAAsD;AAC1D;AACA;IACI,gDAA8D;AAClE;AACA;IACI,gDAA6D;AACjE;AACA;IACI,gDAAqD;AACzD;AACA;IACI,gDAAgD;AACpD;AACA;IACI,gDAA8C;AAClD;AACA;IACI,gDAA0D;AAC9D;AACA;IACI,gDAAoD;AACxD;AACA;IACI,gDAAkE;AACtE;AACA;IACI,iDAAkD;AACtD;AACA;IACI,iDAAiD;AACrD;AACA;IACI,iDAA8C;AAClD;AACA;IACI,iDAAmD;AACvD;AACA;IACI,iDAAsD;AAC1D;AACA;IACI,iDAA0D;AAC9D;AACA;IACI,iDAA2D;AAC/D;AACA;IACI,iDAA+C;AACnD;AACA;IACI,iDAA8C;AAClD;AACA;IACI,iDAA8C;AAClD;AACA;IACI,iDAAmD;IACnD,uBAAuB;AAC3B;AACA;IACI,iDAAmD;IACnD,yBAAyB;AAC7B;AACA;IACI,iDAAqD;AACzD;AACA;IACI,iDAAqD;IACrD,yBAAyB;AAC7B;AACA;IACI,iDAAqD;IACrD,yBAAyB;AAC7B;AACA;IACI,iDAAqD;IACrD,wBAAwB;AAC5B;;AAEA;;+EAE+E;AAC/E;IACI,cAAc;IACd,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;;+EAE+E;AAC/E;IACI,cAAc;IACd,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;+EAE+E;AAC/E;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;+EAE+E;AAC/E;;IAEI,iCAAiC;AACrC;AACA,sEAAsE;AACtE;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA,2DAA2D;AAC3D;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[":host {\n    position: relative;\n    display: inline-block;\n}\n:host([kind]) img {\n    display: block;\n    width: var(--p2-regular-font-size);\n    height: var(--p2-regular-font-size);\n    margin-left: var(--spacing-05);\n    margin-right: var(--spacing-05);\n}\n:host([kind=\"success\"]) img {\n    content: url(\"src/foundations/icons/circle-check-green.svg\");\n}\n:host([kind=\"check\"]) img {\n    content: url(\"src/foundations/icons/circle-check.svg\");\n}\n:host([kind=\"error\"]) img {\n    content: url(\"src/foundations/icons/triangle-exclamation.svg\");\n}\n:host([kind=\"warning\"]) img {\n    content: url(\"src/foundations/icons/circle-info-warning.svg\");\n}\n:host([kind=\"info\"]) img {\n    content: url(\"src/foundations/icons/circle-info.svg\");\n}\n:host([kind=\"rotate\"]) img {\n    content: url(\"src/foundations/icons/rotate.svg\");\n}\n:host([kind=\"lock\"]) img {\n    content: url(\"src/foundations/icons/lock.svg\");\n}\n:host([kind=\"search\"]) img {\n    content: url(\"src/foundations/icons/magnifying-glass.svg\");\n}\n:host([kind=\"user\"]) img {\n    content: url(\"src/foundations/icons/user-large.svg\");\n}\n:host([kind=\"logout\"]) img {\n    content: url(\"src/foundations/icons/arrow-right-from-bracket.svg\");\n}\n:host([kind=\"pdf\"]) img {\n    content: url(\"src/foundations/icons/file-pdf.svg\");\n}\n:host([kind=\"comment\"]) img {\n    content: url(\"src/foundations/icons/comment.svg\");\n}\n:host([kind=\"save\"]) img {\n    content: url(\"src/foundations/icons/save.svg\");\n}\n:host([kind=\"trash-red\"]) img {\n    content: url(\"src/foundations/icons/trash-red.svg\");\n}\n:host([kind=\"remove\"]) img {\n    content: url(\"src/foundations/icons/circle-xmark.svg\");\n}\n:host([kind=\"remove-red\"]) img {\n    content: url(\"src/foundations/icons/circle-xmark-red.svg\");\n}\n:host([kind=\"history\"]) img {\n    content: url(\"src/foundations/icons/clock-rotate-left.svg\");\n}\n:host([kind=\"clone\"]) img {\n    content: url(\"src/foundations/icons/clone.svg\");\n}\n:host([kind=\"edit\"]) img {\n    content: url(\"src/foundations/icons/edit.svg\");\n}\n:host([kind=\"plus\"]) img {\n    content: url(\"src/foundations/icons/plus.svg\");\n}\n:host([kind=\"direction-down\"]) img {\n    content: url(\"src/foundations/icons/direction.svg\");\n    transform: rotate(0deg);\n}\n:host([kind=\"direction-up\"]) img {\n    content: url(\"src/foundations/icons/direction.svg\");\n    transform: rotate(180deg);\n}\n:host([kind=\"arrow-right\"]) img {\n    content: url(\"src/foundations/icons/arrow-right.svg\");\n}\n:host([kind=\"arrow-left\"]) img {\n    content: url(\"src/foundations/icons/arrow-right.svg\");\n    transform: rotate(180deg);\n}\n:host([kind=\"arrow-up\"]) img {\n    content: url(\"src/foundations/icons/arrow-right.svg\");\n    transform: rotate(270deg);\n}\n:host([kind=\"arrow-down\"]) img {\n    content: url(\"src/foundations/icons/arrow-right.svg\");\n    transform: rotate(90deg);\n}\n\n/* =============================================================================\n   m icons\n   ===========================================================================*/\n:host([size=\"m\"]) img {\n    display: block;\n    width: var(--headings-h4-font-size);\n    height: var(--headings-h4-font-size);\n    margin-left: var(--spacing-05);\n    margin-right: var(--spacing-05);\n}\n/* =============================================================================\n   lg icons\n   ===========================================================================*/\n:host([size=\"lg\"]) img {\n    display: block;\n    width: var(--headings-h2-font-size);\n    height: var(--headings-h2-font-size);\n    margin-left: var(--spacing-05);\n    margin-right: var(--spacing-05);\n}\n\n/* =============================================================================\n   disabled icons\n   ===========================================================================*/\n:host([disabled]) img {\n    opacity: .4;\n    cursor: default;\n}\n\n/* =============================================================================\n   animated arrow icons\n   ===========================================================================*/\n:host([kind=\"direction-down\"]) img.animate,\n:host([kind=\"direction-up\"]) img.animate {\n    transition: transform .13s linear;\n}\n/*animated icons start with con configuration far from the ideal onde*/\n:host([kind=\"direction-down\"][animate]) img {\n    transform: rotate(180deg);\n}\n:host([kind=\"direction-up\"][animate]) img {\n    transform: rotate(0deg);\n}\n/*and then return to the ideal configuration via animation*/\n:host([kind=\"direction-down\"][animate]) img.animate {\n    transform: rotate(0deg);\n}\n:host([kind=\"direction-up\"][animate]) img.animate {\n    transform: rotate(180deg);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
